import { Body, Box, Heading } from '@hover/blueprint';
import { chakra } from '@hover/blueprint/chakra';
import React from 'react';

import {
  TranslationNamespace,
  useReactNativeWebView,
  useTranslate,
} from 'src/shared/hooks';
import { WebViewScope } from 'src/shared/hooks/useReactNativeWebView';

import desktop from 'assets/video/desktop-saved-landscape.mp4';
import mobilePortrait from 'assets/video/mobile-saved-portrait.mp4';

import { MobileHeader } from '../MobileHeader';
import { StackingHeaderProvider } from '../StackingHeader';

const Video = chakra('video', {
  baseStyle: {
    width: '100%',
    borderRadius: { tablet: '300' },
  },
});

const EmptyFavorites = () => {
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);
  const [isWebView] = useReactNativeWebView(WebViewScope.MOBILE_HOMEOWNER);

  return (
    <StackingHeaderProvider
      height={{
        desktop: { expanded: 130, collapsed: 60 },
        mobile: { expanded: 80, collapsed: 0 },
      }}
    >
      {!isWebView && (
        <MobileHeader
          headingText=""
          isLoading={false}
          showHeaderText={false}
          showProfileIcon
          showSubHeading={false}
        />
      )}
      <Box
        alignItems={{ base: 'center', tablet: 'start' }}
        flexDirection={{ base: 'column', tablet: 'row' }}
        gap={{ base: 800, tablet: 1000 }}
        height="100%"
        justifyContent="center"
        mt={{ base: 300, tablet: 700 }}
        mx={{ tablet: 800 }}
      >
        <Box
          alignItems="start"
          display="flex"
          flexDirection="column"
          gap={300}
          mx={{ base: 500, tablet: 0 }}
        >
          <Heading mb={0}>{t('favorites.noSavedYet')}</Heading>
          <Body color="neutral.textLight" m={0}>
            {t('favorites.tapTheBookmark')}
          </Body>
        </Box>
        <Box width={{ base: '100%', tablet: '80%' }}>
          <Video
            autoPlay
            display={{ tablet: 'none' }}
            loop
            muted
            playsInline
            src={mobilePortrait}
          />
          <Video
            autoPlay
            display={{ mobile: 'none', tablet: 'block' }}
            loop
            muted
            playsInline
            src={desktop}
          />
        </Box>
      </Box>
    </StackingHeaderProvider>
  );
};

export { EmptyFavorites };
